const nasobilkaTri = () => {
	return [
		{
			id: 1,
			priklad: '3 x 4',
			moznosti: [
				{
					id: 1,
					moznost: '6',
				},
				{
					id: 2,
					moznost: '12',
				},
				{
					id: 3,
					moznost: '15',
				},
				{
					id: 4,
					moznost: '9',
				},
			],
			vysledek: '12',
		},
		{
			id: 2,
			priklad: '18 : 3',
			moznosti: [
				{
					id: 1,
					moznost: '8',
				},
				{
					id: 2,
					moznost: '9',
				},
				{
					id: 3,
					moznost: '7',
				},
				{
					id: 4,
					moznost: '6',
				},
			],
			vysledek: '6',
		},
		{
			id: 3,
			priklad: '5 x 3',
			moznosti: [
				{
					id: 1,
					moznost: '9',
				},
				{
					id: 2,
					moznost: '12',
				},
				{
					id: 3,
					moznost: '18',
				},
				{
					id: 4,
					moznost: '15',
				},
			],
			vysledek: '15',
		},
		{
			id: 4,
			priklad: '9 : 3',
			moznosti: [
				{
					id: 1,
					moznost: '4',
				},
				{
					id: 2,
					moznost: '3',
				},
				{
					id: 3,
					moznost: '6',
				},
				{
					id: 4,
					moznost: '2',
				},
			],
			vysledek: '3',
		},
		{
			id: 5,
			priklad: '3 x 2',
			moznosti: [
				{
					id: 1,
					moznost: '6',
				},
				{
					id: 2,
					moznost: '9',
				},
				{
					id: 3,
					moznost: '3',
				},
				{
					id: 4,
					moznost: '12',
				},
			],
			vysledek: '6',
		},
		{
			id: 6,
			priklad: '7 x 3',
			moznosti: [
				{
					id: 1,
					moznost: '15',
				},
				{
					id: 2,
					moznost: '24',
				},
				{
					id: 3,
					moznost: '21',
				},
				{
					id: 4,
					moznost: '18',
				},
			],
			vysledek: '21',
		},
		{
			id: 7,
			priklad: '9 x 3',
			moznosti: [
				{
					id: 1,
					moznost: '24',
				},
				{
					id: 2,
					moznost: '21',
				},
				{
					id: 3,
					moznost: '30',
				},
				{
					id: 4,
					moznost: '27',
				},
			],
			vysledek: '27',
		},
		{
			id: 8,
			priklad: '30 : 3',
			moznosti: [
				{
					id: 1,
					moznost: '10',
				},
				{
					id: 2,
					moznost: '9',
				},
				{
					id: 3,
					moznost: '7',
				},
				{
					id: 4,
					moznost: '8',
				},
			],
			vysledek: '10',
		},
		{
			id: 9,
			priklad: '3 x 6',
			moznosti: [
				{
					id: 1,
					moznost: '12',
				},
				{
					id: 2,
					moznost: '18',
				},
				{
					id: 3,
					moznost: '15',
				},
				{
					id: 4,
					moznost: '21',
				},
			],
			vysledek: '18',
		},
		{
			id: 10,
			priklad: '12 : 3',
			moznosti: [
				{
					id: 1,
					moznost: '2',
				},
				{
					id: 2,
					moznost: '5',
				},
				{
					id: 3,
					moznost: '3',
				},
				{
					id: 4,
					moznost: '4',
				},
			],
			vysledek: '4',
		},
		{
			id: 11,
			priklad: '27 : 3',
			moznosti: [
				{
					id: 1,
					moznost: '6',
				},
				{
					id: 2,
					moznost: '7',
				},
				{
					id: 3,
					moznost: '9',
				},
				{
					id: 4,
					moznost: '8',
				},
			],
			vysledek: '9',
		},
		{
			id: 12,
			priklad: '9 : 3',
			moznosti: [
				{
					id: 1,
					moznost: '3',
				},
				{
					id: 2,
					moznost: '4',
				},
				{
					id: 3,
					moznost: '5',
				},
				{
					id: 4,
					moznost: '2',
				},
			],
			vysledek: '3',
		},
		{
			id: 13,
			priklad: '3 : 3',
			moznosti: [
				{
					id: 1,
					moznost: '2',
				},
				{
					id: 2,
					moznost: '3',
				},
				{
					id: 3,
					moznost: '1',
				},
				{
					id: 4,
					moznost: '0',
				},
			],
			vysledek: '1',
		},
		{
			id: 14,
			priklad: '2 x 3',
			moznosti: [
				{
					id: 1,
					moznost: '12',
				},
				{
					id: 2,
					moznost: '3',
				},
				{
					id: 3,
					moznost: '6',
				},
				{
					id: 4,
					moznost: '9',
				},
			],
			vysledek: '6',
		},
		{
			id: 15,
			priklad: '4 x 3',
			moznosti: [
				{
					id: 1,
					moznost: '6',
				},
				{
					id: 2,
					moznost: '18',
				},
				{
					id: 3,
					moznost: '9',
				},
				{
					id: 4,
					moznost: '12',
				},
			],
			vysledek: '12',
		},
		{
			id: 16,
			priklad: '3 x 5',
			moznosti: [
				{
					id: 1,
					moznost: '12',
				},
				{
					id: 2,
					moznost: '18',
				},
				{
					id: 3,
					moznost: '15',
				},
				{
					id: 4,
					moznost: '21',
				},
			],
			vysledek: '15',
		},
		{
			id: 17,
			priklad: '24 : 3',
			moznosti: [
				{
					id: 1,
					moznost: '6',
				},
				{
					id: 2,
					moznost: '8',
				},
				{
					id: 3,
					moznost: '7',
				},
				{
					id: 4,
					moznost: '9',
				},
			],
			vysledek: '8',
		},
		{
			id: 18,
			priklad: '8 x 3',
			moznosti: [
				{
					id: 1,
					moznost: '18',
				},
				{
					id: 2,
					moznost: '27',
				},
				{
					id: 3,
					moznost: '21',
				},
				{
					id: 4,
					moznost: '24',
				},
			],
			vysledek: '24',
		},
		{
			id: 19,
			priklad: '27 : 3',
			moznosti: [
				{
					id: 1,
					moznost: '8',
				},
				{
					id: 2,
					moznost: '9',
				},
				{
					id: 3,
					moznost: '7',
				},
				{
					id: 4,
					moznost: '6',
				},
			],
			vysledek: '9',
		},
		{
			id: 20,
			priklad: '10 x 3',
			moznosti: [
				{
					id: 1,
					moznost: '21',
				},
				{
					id: 2,
					moznost: '27',
				},
				{
					id: 3,
					moznost: '30',
				},
				{
					id: 4,
					moznost: '18',
				},
			],
			vysledek: '30',
		},
		{
			id: 21,
			priklad: '4 x 3',
			moznosti: [
				{
					id: 1,
					moznost: '16',
				},
				{
					id: 2,
					moznost: '12',
				},
				{
					id: 3,
					moznost: '8',
				},
				{
					id: 4,
					moznost: '20',
				},
			],
			vysledek: '12',
		},
		{
			id: 22,
			priklad: '3 x 7',
			moznosti: [
				{
					id: 1,
					moznost: '35',
				},
				{
					id: 2,
					moznost: '14',
				},
				{
					id: 3,
					moznost: '28',
				},
				{
					id: 4,
					moznost: '21',
				},
			],
			vysledek: '21',
		},
		{
			id: 23,
			priklad: '3 x 9',
			moznosti: [
				{
					id: 1,
					moznost: '30',
				},
				{
					id: 2,
					moznost: '27',
				},
				{
					id: 3,
					moznost: '24',
				},
				{
					id: 4,
					moznost: '21',
				},
			],
			vysledek: '27',
		},
		{
			id: 24,
			priklad: '6 x 3',
			moznosti: [
				{
					id: 1,
					moznost: '18',
				},
				{
					id: 2,
					moznost: '15',
				},
				{
					id: 3,
					moznost: '24',
				},
				{
					id: 4,
					moznost: '21',
				},
			],
			vysledek: '18',
		},
		{
			id: 25,
			priklad: '3 x 8',
			moznosti: [
				{
					id: 1,
					moznost: '18',
				},
				{
					id: 2,
					moznost: '27',
				},
				{
					id: 3,
					moznost: '21',
				},
				{
					id: 4,
					moznost: '24',
				},
			],
			vysledek: '24',
		},
	];
};

export default nasobilkaTri;